import { createAction, props } from '@ngrx/store';
import { SupplierApiModel } from '@/core/models/api/supplier-api-model.model';

export const loadProviders = createAction('[Provider] Load All');
export const loadProvidersSuccess = createAction(
    '[Provider] Load All Success',
    props<{ items: SupplierApiModel[] }>()
);
export const loadProvidersFailure = createAction(
    '[Provider] Load All Failure',
    props<{ error: any }>()
);

export const addProvider = createAction(
    '[Provider] Add',
    props<{ item: SupplierApiModel }>()
);
export const addProviderSuccess = createAction(
    '[Provider] Add Success',
    props<{ item: SupplierApiModel }>()
);
export const addProviderFailure = createAction(
    '[Provider] Add Failure',
    props<{ error: any }>()
);

export const updateProvider = createAction(
    '[Provider] Update',
    props<{ item: SupplierApiModel }>()
);
export const updateProviderSuccess = createAction(
    '[Provider] Update Success',
    props<{ item: SupplierApiModel }>()
);
export const updateProviderFailure = createAction(
    '[Provider] Update Failure',
    props<{ error: any }>()
);

export const deleteProvider = createAction(
    '[Provider] Delete',
    props<{ id: number }>()
);
export const deleteProviderSuccess = createAction(
    '[Provider] Delete Success',
    props<{ id: number }>()
);
export const deleteProviderFailure = createAction(
    '[Provider] Delete Failure',
    props<{ error: any }>()
);
